import {createApp} from 'vue'
import CurrentFundPrices from './CurrentFundPrices'
import handleComponentProps from '../../foundation/js/utils/handleComponentProps.js'

const el = '.nyk-component--current-fund-prices'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((CurrentFundPricesDOM) => {
            const props = handleComponentProps(CurrentFundPrices, CurrentFundPricesDOM)
            const component = createApp(CurrentFundPrices, props).use(Store)
            component.mount(CurrentFundPricesDOM)
        })
    }
}